import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App.jsx';
import InitialDataProvider from './ssr/InitialDataProvider.jsx';

const initialData = typeof window !== 'undefined' && window.__INITIAL_DATA__ ? window.__INITIAL_DATA__ : {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <InitialDataProvider data={initialData}>
        <App />
      </InitialDataProvider>
    </HelmetProvider>
  </React.StrictMode>
);
